// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3C3ei","location":"Header_location__1pg6X"};